import * as yup from 'yup'
import { TextareaType } from '../../static/types/commonTypes/textAreaType'

export const requiredTextAreaValidationSchema = ( errorMessage: string ): yup.ObjectSchema<TextareaType> => {
    return yup.object({
        value: yup
        .string()
        .required( errorMessage )
    })
}

export const optionalTextAreaValidationSchema = yup.object({
    value: yup
    .string()
    .optional()
})
